// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import 'bootstrap/dist/css/bootstrap.min.css';
import BootstrapVue from 'bootstrap-vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faImages,
  faCheck,
  faExclamationTriangle,
  faAngry,
  faAngleDoubleLeft,
  faKey,
  faEye,
  faUserCheck,
  faClock,
  faUserSlash,
  faPortrait,
  faMobileAlt,
  faChessQueen,
  faCircle,
  faUserTimes,
  faPencilAlt,
  faMars,
  faVenus,
  faBan, faAlignRight, faPlus,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import store from './store';

Vue.component('font-awesome-icon', FontAwesomeIcon);
library.add(
  faImages, faUserTimes,
  faCheck, faCircle,
  faAngleDoubleLeft,
  faKey, faChessQueen,
  faExclamationTriangle,
  faAngry, faPortrait, faMobileAlt,
  faEye, faUserCheck, faClock, faUserSlash,
  faBan, faVenus, faVenus, faMars, faPencilAlt,
  faAlignRight, faTimes, faPlus
);

Vue.config.productionTip = false;
Vue.use(BootstrapVue);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App,
    FontAwesomeIcon,
  },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js